import {assertAndContinue} from 'Asserts';
import {
  Capability,
  UnimplementedCapability,
  USER_PREFERENCE_GATED_CAPABILITIES,
} from 'auth/capabilities/CapabilityFeatureConstants';
import BenchlingConfig from 'BenchlingConfig';

import {legacyIsCapabilityEnabled} from './getCapabilityFeatures';

let tenantProvisionableCapabilities: Set<Capability> | null =
  makeTenantProvisionableCapabilitiesSetFromBootstrap();

function makeTenantProvisionableCapabilitiesSetFromBootstrap(): Set<Capability> | null {
  if (!window.bootstrap?.tenantProvisionableCapabilities) {
    return null;
  }
  return new Set(window.bootstrap.tenantProvisionableCapabilities);
}

// Only for manipulating tenantProvisionableCapabilities in tests
export function _setEnabledTenantProvisionableCapabilities(capabilities: Set<Capability>): void {
  tenantProvisionableCapabilities = capabilities;
}

export default function isCapabilityEnabledForTenant(
  capability: Exclude<Capability, UnimplementedCapability>
): boolean {
  const userPrefGatedCapabilities = USER_PREFERENCE_GATED_CAPABILITIES as unknown as Array<Capability>;
  if (BenchlingConfig.IDENTITY_ENABLE_CAPABILITY_GATING && !userPrefGatedCapabilities.includes(capability)) {
    assertAndContinue(
      tenantProvisionableCapabilities != null,
      'Tried to check tenantProvisionableCapabilities but it was not available'
    );
    return tenantProvisionableCapabilities != null ? tenantProvisionableCapabilities.has(capability) : false;
  }
  // If Capability Management is turned off, use the legacy ENABLE_[APPLICATION] flag
  return legacyIsCapabilityEnabled(capability);
}
